import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface AuthProvider {
  init(): Promise<void>;
  readonly isAuthenticated$: Observable<boolean>;
  getAccessToken(): Promise<string>;
  logout(): Promise<void>;
}

export const AUTH_PROVIDER = new InjectionToken<AuthProvider>('AUTH_PROVIDER');

export class AuthCallbackError extends Error {
  constructor(
    readonly error: string,
    readonly description: string | null,
  ) {
    super(`${error}: ${description ?? ''}`);
    this.name = 'AuthCallbackError';
  }
}

export const NEVER_RESOLVES = <T>(): Promise<T> => new Promise<T>(() => undefined);
